import {
  Card,
  Stack,
  Typography,
  Switch,
  ToggleButtonGroup,
  ToggleButton,
  TextField,
  Grid,
  FormControl,
  MenuItem,
  Select,
  Popper,
  Grow,
  Box,
  Button,
} from "@mui/material";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { createTrafficAnalysisStarUrl } from "Redux/starSlice";
import {
  changeMode,
  changeDriverName,
  changePlaque,
  FleetModeType,
  toggleVisibility,
  togglePointwiseShow,
  changeTrafficFleetShowType,
} from "Redux/trafficFleetSlice";
import CarSearch from "../carSearch";

export default function Fleet() {
  const dispatch = useAppDispatch();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const controlEl: any = useRef();

  const { mode, plaque, driverName, visible, pointwiseShow, trafficFleetShowType } = useAppSelector(
    (state) => state.trafficFleet
  );
  const label = { inputProps: { "aria-label": "Switch demo" } };

  const handleVisible = () => {
    dispatch(toggleVisibility());
  };

  const handleMode = (event: React.MouseEvent<HTMLElement>, newMode: FleetModeType) => {
    const { currentTarget } = event;
    setAnchorEl(currentTarget);
    dispatch(changeMode(newMode));
  };

  const handleDriverName = (event: any) => {
    dispatch(changeDriverName(event.target.value));
  };

  useEffect(() => {
    setAnchorEl(controlEl.current);
  }, []);

  const handleMarkerPointWise = () => {
    dispatch(togglePointwiseShow());
  };

  const handleTrafficFleetShowType = (event: React.MouseEvent<HTMLElement>, newMode: any) => {
    if (newMode !== null) {
      dispatch(changeTrafficFleetShowType(Number(newMode)));
    }
  };

  const handleSwitch = () => {
    const purePlaque = `${plaque.plaquePart4}${plaque.plaquePart3}${plaque.plaquePart2}${plaque.plaquePart1}`;
    dispatch(toggleVisibility());

    dispatch(
      createTrafficAnalysisStarUrl([
        `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=c18873dd-5f75-4060-97a5-550cf5ddb306&paramvalues={"01597144-d5c1-0a9d-f160-183f71687a06":[{"Value":{"Id":null,"Value":"2024-05-25T00:00:00","DisplayValue":null},"FromColumn":false,"SelectedField":null}],"fb740de5-b55e-3c12-f5bd-05d10473ce47":[{"Value":{"Id":null,"Value":"2024-06-25T00:00:00","DisplayValue":null},"FromColumn":false,"SelectedField":null}],"14268a78-33a9-f49f-f287-dabc1ce52869":[{"Value":{"Id":${purePlaque},"Value":${purePlaque},"DisplayValue":${purePlaque}},"FromColumn":false,"SelectedField":null}]}`,
        `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=bbe7e5bd-857d-432a-a75a-584546021174&paramvalues={"01597144-d5c1-0a9d-f160-183f71687a06":[{"Value":{"Id":null,"Value":"2024-05-25T00:00:00","DisplayValue":null},"FromColumn":false,"SelectedField":null}],"fb740de5-b55e-3c12-f5bd-05d10473ce47":[{"Value":{"Id":null,"Value":"2024-06-25T00:00:00","DisplayValue":null},"FromColumn":false,"SelectedField":null}],"14268a78-33a9-f49f-f287-dabc1ce52869":[{"Value":{"Id":${purePlaque},"Value":${purePlaque},"DisplayValue":${purePlaque}},"FromColumn":false,"SelectedField":null}]}`,
      ])
    );
  };

  return (
    <Card sx={{ p: 1.5 }}>
      <Stack spacing={2} direction="row" sx={{ justifyContent: "space-between" }}>
        <Grid container spacing={1} sx={{ width: "800px" }}>
          <Grid item xs={12} md={5.5}>
            <CarSearch />
          </Grid>
          <Grid item xs={12} md={3.5}>
            <Box sx={{ mb: 1 }}>
              <TextField
                id="outlined-basic"
                label="جستجوی راننده"
                variant="outlined"
                value={driverName}
                onChange={handleDriverName}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={2}>
            <ToggleButtonGroup
              value={Number(trafficFleetShowType)}
              onChange={handleTrafficFleetShowType}
              exclusive
              aria-label="traffic-show-type"
            >
              <ToggleButton
                value={0}
                aria-label="traffic-mode-0"
                style={{
                  width: "80px",
                  height: "56px",
                  backgroundColor: Number(trafficFleetShowType) === 0 ? "#4754CA" : "",
                  color: Number(trafficFleetShowType) === 0 ? "#fff" : "",
                }}
              >
                مارکر
              </ToggleButton>
              <ToggleButton
                value={1}
                aria-label="traffic-mode-1"
                style={{
                  width: "80px",
                  height: "56px",
                  backgroundColor: Number(trafficFleetShowType) === 1 ? "#4754CA" : "",
                  color: Number(trafficFleetShowType) === 1 ? "#fff" : "",
                }}
              >
                هیت مپ گرادیان
              </ToggleButton>
            </ToggleButtonGroup>
          </Grid>
        </Grid>
        {trafficFleetShowType === 0 ? (
          <Button
            onClick={handleMarkerPointWise}
            variant={pointwiseShow ? "contained" : "light"}
            style={{ marginRight: "10px", marginBottom: "8px" }}
          >
            نمایش نقطه ای
          </Button>
        ) : null}

        <Stack direction="row" style={{ justifyContent: "space-between", alignItems: "center" }}>
          <Typography sx={{ fontSize: "18px !important", mb: "0 !important" }}>نمایش</Typography>
          <Switch {...label} onChange={handleSwitch} checked={visible} />
        </Stack>
      </Stack>
    </Card>
  );
}
